import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeAttendance, PresenceStatus } from '../../attendance.model';
import { convertUTCtoIST, getDefaultProfilePicUrl, handleImageError } from '../../../utils';
import moment from 'moment';

@Component({
  selector: 'app-attendance-status-card',
  standalone: false,
  templateUrl: './attendance-status-card.component.html',
  styleUrl: './attendance-status-card.component.scss',
})
export class AttendanceStatusCardComponent {
  @Input() title!: string;
  @Input() bgColorClass: string = 'bg-light';
  @Input() textColorClass: string = 'text-dark';
  @Input() employees: EmployeeAttendance[] = [];
  @Input() emptyMessage: string = 'No records available';

  searchQuery: string = '';

  protected readonly getDefaultProfilePicUrl = getDefaultProfilePicUrl;
  protected readonly handleImageError = handleImageError;
  protected readonly moment = moment;
  protected readonly convertUTCtoIST = convertUTCtoIST;
  protected readonly PresenceStatus = PresenceStatus;

  constructor(private _router: Router) {}

  get filteredEmployees(): EmployeeAttendance[] {
    const q = this.searchQuery.trim().toLowerCase();
    if (!q) return this.employees;
    return this.employees.filter(emp => `${emp.first_name} ${emp.last_name}`.toLowerCase().includes(q));
  }

  protected onEmployeeClick(emp: EmployeeAttendance): void {
    if (emp.status === PresenceStatus.YET_TO_CHECK_IN) return;
    this._router.navigate(['/attendance', emp.id], {
      state: { name: `${emp.first_name} ${emp.last_name}`, status: emp.status },
    });
  }
}
